"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3236],{

/***/ 29918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AdvertisementSlot": function() { return /* reexport */ AdvertisementSlot; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
;// CONCATENATED MODULE: ./src/components/AdvertisementSlot/@editor/index.ts


var useEditorHandlers = function(name, configuration) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_advertisement_slot_background_color",
                label: "Background color",
                type: "color",
                default: theme.palette.divider
            },
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Label"
            },
            {
                name: "theme_component_advertisement_slot_label_background_color",
                label: "Background color",
                type: "color",
                default: theme.palette.secondary.main
            },
            {
                name: "theme_component_advertisement_slot_label_color",
                label: "Text color",
                type: "color",
                default: theme.palette.secondary.contrastText
            }, 
        ],
        configuration: configuration
    });
};

// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./src/components/PaperColorElevation/index.ts + 1 modules
var PaperColorElevation = __webpack_require__(80830);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 5 modules
var AppContext = __webpack_require__(24911);
// EXTERNAL MODULE: ./src/utils/use-local-storage.ts
var use_local_storage = __webpack_require__(18714);
;// CONCATENATED MODULE: ./src/components/AdvertisementSlot/AdvertisementSlot.tsx















var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "e4qvkgu0"
})(function(param) {
    var theme = param.theme;
    return {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: theme.spacing(0)
    };
});
var Label = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qvkgu1"
})(function(param) {
    var theme = param.theme;
    return {
        position: "absolute",
        top: 0,
        left: theme.spacing(2),
        padding: theme.spacing(0.25, 1),
        color: theme.theme_component_advertisement_slot_label_color || theme.palette.secondary.contrastText,
        backgroundColor: theme.theme_component_advertisement_slot_label_background_color || theme.palette.secondary.main,
        borderRadius: "".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0 0"),
        transform: "translateY(-90%) scale(0.75)"
    };
});
var Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qvkgu2"
})("display:flex;justify-content:center;align-items:center;width:100%;height:100%;");
var AdvertisementSlot_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var SlotContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qvkgu3"
})(function(param) {
    var variant = param.variant;
    var styles;
    if (variant) {
        switch(variant){
            case "120x600":
                styles = {
                    width: 120,
                    height: 600
                };
                break;
            case "320x50":
                styles = {
                    width: 320,
                    height: 50
                };
                break;
            case "970x90":
                styles = {
                    width: 970,
                    height: 90
                };
                break;
            case "970x250":
                styles = {
                    width: 970,
                    height: 250
                };
                break;
            case "336x280":
                styles = {
                    width: 336,
                    height: 250
                };
                break;
            case "300x250":
                styles = {
                    width: 300,
                    height: 250
                };
                break;
            case "728x90":
                styles = {
                    width: 728,
                    height: 90
                };
                break;
            case "300x600":
                styles = {
                    width: 300,
                    height: 600
                };
                break;
            case "160x600":
                styles = {
                    width: 160,
                    height: 600
                };
                break;
        }
    }
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, styles), {
        overflow: "hidden"
    });
});
var AdvertisementSlot = function(props) {
    var className = props.className, variant = props.variant, slotIdentifier = props.slotIdentifier, alignment = props.alignment, configuration = props.configuration, other = (0,_object_without_properties/* default */.Z)(props, [
        "className",
        "variant",
        "slotIdentifier",
        "alignment",
        "configuration"
    ]);
    var captionRef = react.useRef(null);
    var themeOverride = (0,useTheme/* default */.Z)();
    var t = (0,useTranslation/* useTranslation */.$)("advertisement_slot").t;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var componentOptions = appContext.useConfig().componentOptions;
    var subMode = componentOptions.component_project_subscription_mode;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_local_storage/* default */.Z)("user-token", ""), 2), userToken = ref[0], setUserToken = ref[1];
    var hideAdvertisement = subMode && userToken;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, useEditorHandlers("Advertisement Slot", configuration), other), {
        children: hideAdvertisement ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlot_Typography, {
                        ref: captionRef,
                        variant: "caption",
                        component: "div",
                        children: t("label", "Advertisement")
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SlotContainer, {
                    variant: variant,
                    slotIdentifier: slotIdentifier,
                    theme: themeOverride,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Inner, {
                        id: slotIdentifier,
                        style: {
                            justifyContent: alignment
                        }
                    })
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/AdvertisementSlot/index.ts



/***/ }),

/***/ 7500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* unused harmony export NextLinkComposed */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90512);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90948);
/* harmony import */ var next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73966);
/* harmony import */ var next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23795);
/* harmony import */ var _contexts_CursorContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15888);












// Add support for the sx prop for consistency with the other branches.
var Anchor = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)("a")({});
var NextLinkComposed = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function NextLinkComposed(props, ref) {
    var to = props.to, linkAs = props.linkAs, replace = props.replace, scroll = props.scroll, shallow = props.shallow, prefetch = props.prefetch, locale = props.locale, storybook = props.storybook, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props, [
        "to",
        "linkAs",
        "replace",
        "scroll",
        "shallow",
        "prefetch",
        "locale",
        "storybook"
    ]);
    return storybook ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: to,
        prefetch: prefetch,
        as: linkAs,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        passHref: true,
        locale: locale,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Anchor, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            ref: ref
        }, other))
    }) : /* next-translate-routes/link is using the wrong Type for next/link. */ /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)((next_translate_routes_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: to,
        prefetch: prefetch,
        as: linkAs,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        passHref: true,
        locale: locale,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Anchor, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            ref: ref
        }, other))
    });
});
// A styled version of the Next.js Link component:
// https://nextjs.org/docs/api-reference/next/link
var Link = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Link(props, ref) {
    var _activeClassName = props.activeClassName, activeClassName = _activeClassName === void 0 ? "active" : _activeClassName, as = props.as, classNameProps = props.className, href = props.href, linkAsProp = props.linkAs, locale = props.locale, noLinkStyle = props.noLinkStyle, prefetch = props.prefetch, replace = props.replace, role = props.role, scroll = props.scroll, shallow = props.shallow, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props, [
        "activeClassName",
        "as",
        "className",
        "href",
        "linkAs",
        "locale",
        "noLinkStyle",
        "prefetch",
        "replace",
        "role",
        "scroll",
        "shallow"
    ]);
    var enabled = (0,_contexts_CursorContext__WEBPACK_IMPORTED_MODULE_4__/* .useCursorContext */ .r)().enabled;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var storybook = router === null || router === void 0 ? void 0 : router.storybook;
    var pathname = typeof href === "string" ? href : href.pathname;
    var className = (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(classNameProps, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, activeClassName, router.pathname === pathname && activeClassName));
    var isExternal = typeof href === "string" && (href.indexOf("http") === 0 || href.indexOf("mailto:") === 0);
    if (isExternal) {
        if (noLinkStyle) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Anchor, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                className: className,
                href: enabled ? "#" : href,
                ref: ref
            }, other));
        }
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            className: className,
            href: enabled ? "#" : href,
            ref: ref
        }, other));
    }
    var linkAs = linkAsProp || as;
    var nextjsProps = {
        to: enabled ? "#" : href,
        linkAs: linkAs,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        prefetch: prefetch,
        locale: locale,
        storybook: storybook
    };
    if (noLinkStyle) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(NextLinkComposed, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            className: className,
            ref: ref
        }, nextjsProps, other));
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        component: NextLinkComposed,
        className: className,
        ref: ref
    }, nextjsProps, other));
});


/***/ }),

/***/ 80830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ PaperColorElevation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
;// CONCATENATED MODULE: ./src/components/PaperColorElevation/PaperColorElevation.tsx







var PaperStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Paper/* default */.Z, {
    target: "e4eo54y0"
})(function(param) {
    var theme = param.theme, elevation = param.elevation;
    return {
        boxShadow: theme.shadows[elevation || 1],
        backgroundColor: theme.palette.mode === "dark" ? (0,colorManipulator/* lighten */.$n)(theme.palette.background.paper, elevation ? elevation * 0.025 : 0) : (0,colorManipulator/* darken */._j)(theme.palette.background.paper, elevation ? elevation * 0.025 : 0)
    };
});
var PaperColorElevation = function(props) {
    var children = props.children, other = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaperStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/PaperColorElevation/index.ts



/***/ }),

/***/ 78958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHighlightHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54794);







// Todo: Have a hard time setting the type for Component, as it can be Mui Typography or our own Link component.
var useHighlightHandlers = function(Component, props) {
    var enabledVariants = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* .useHighlightContext */ .A)().enabledVariants;
    var forwardedRef = props.forwardedRef, variant = props.variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "forwardedRef",
        "variant"
    ]);
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var element = null;
    // Todo: Not sure how to resolve this missing current ts warning.
    // @ts-ignore
    if (forwardedRef && (forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current)) {
        // Todo: Not sure how to resolve this missing current ts warning.
        // @ts-ignore
        element = forwardedRef.current;
    }
    if (element && variant && Array.isArray(enabledVariants)) {
        if (enabledVariants.includes(variant)) {
            element.style.outline = "2px dotted ".concat(theme.palette.info.main);
            element.style.outlineOffset = "-2px";
            element.style.position = "relative";
            if (!element.querySelector(".typographyBadge")) {
                var badge = document.createElement("div");
                badge.classList.add("typographyBadge");
                badge.style.position = "absolute";
                badge.style.top = theme.spacing(-0.5);
                badge.style.right = theme.spacing(-0.5);
                badge.style.backgroundColor = theme.palette.info.main;
                badge.style.borderRadius = "".concat(theme.shape.borderRadius, "px");
                badge.style.color = theme.palette.info.contrastText;
                badge.style.fontSize = "10px";
                badge.style.lineHeight = "10px";
                badge.style.padding = theme.spacing(0.5, 1);
                badge.style.boxShadow = theme.shadows[1];
                badge.style.textTransform = "capitalize";
                badge.innerText = [
                    "contained",
                    "text",
                    "outlined"
                ].includes(variant) ? "button" : variant;
                element.appendChild(badge);
            }
        } else {
            var ref;
            element.style.outline = "unset";
            (ref = element.querySelector(".typographyBadge")) === null || ref === void 0 ? void 0 : ref.remove();
        }
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        variant: variant,
        ref: forwardedRef
    }));
};


/***/ }),

/***/ 97691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ BaseLayout; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/layouts/DefaultNestedLayout/index.tsx

/**
 * This component is used as fallback nested layout in case no layout component for a page
 * is set during a BigBang site build.
 *
 * This layout can be used as example "NestedLayout" component within our NPM framework.
 *
 * @param props LayoutProps
 * @constructor
 */ function DefaultNestedLayout(props) {
    var children = props.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: children
    });
}

;// CONCATENATED MODULE: ./src/layouts/DefaultLayout/index.tsx



/**
 * Extend the page view component with this component through "Component.getLayout".
 * This component is used as higher order component within _app.tsx.
 * https://nextjs.org/docs/basic-features/layouts
 * @param props LayoutProps
 * @constructor
 */ function DefaultLayout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultNestedLayout, {
        pageContext: pageContext,
        children: children
    });
}

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/ads-request.ts
var ads_request = __webpack_require__(18505);
// EXTERNAL MODULE: ./src/components/AdvertisementSlot/index.ts + 2 modules
var AdvertisementSlot = __webpack_require__(29918);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 5 modules
var AppContext = __webpack_require__(24911);
// EXTERNAL MODULE: ./src/types/static.tsx
var types_static = __webpack_require__(17637);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/contexts/CursorContext/index.tsx
var CursorContext = __webpack_require__(15888);
;// CONCATENATED MODULE: ./src/layouts/LayoutA/LayoutAds.tsx











var SectionRight = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ke4zxi0"
})(function(param) {
    var theme = param.theme;
    return {
        width: 300,
        marginTop: theme.spacing(7),
        paddingBottom: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        "@media screen and (max-width: 1220px)": {
            display: "none"
        }
    };
});
var AdvertisementSlotTop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(AdvertisementSlot.AdvertisementSlot, {
    target: "e1ke4zxi1"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0]
    };
});
var AdvertisementSlotBottom = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(AdvertisementSlot.AdvertisementSlot, {
    target: "e1ke4zxi2"
})(function(param) {
    var theme = param.theme;
    return {
        boxShadow: theme.shadows[0],
        marginTop: theme.spacing(4)
    };
});
var AdvertisementTop = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotTop, {
        configuration: types_static/* LAYOUTADSCONFIGRATION_AC */._x,
        areaName: "aLayoutRightTopAds",
        elevation: 1,
        slotIdentifier: "idhb-right-300",
        variant: "300x600"
    });
};
var AdvertisementBottom = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementSlotBottom, {
        configuration: types_static/* LAYOUTADSCONFIGRATION_AC_BOTTOM */.LL,
        areaName: "aLayoutRightTopAds",
        elevation: 1,
        slotIdentifier: "idhb-right-small-300",
        variant: "300x600"
    });
};
var LayoutAds = function() {
    var router = (0,next_router.useRouter)();
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var theme = (0,useTheme/* default */.Z)();
    var lg = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    var isBetweenMdAndLg = (0,useMediaQuery/* default */.Z)(theme.breakpoints.between("md", "lg"));
    var mdDown = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    var componentOptions = appContext.useConfig().componentOptions;
    var panel = (0,CursorContext/* useCursorContext */.r)().panel;
    // {xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536}
    var layoutAdsElements = {
        "idhb-right-300": !(componentOptions.component_layout_right_ads_disabled || componentOptions.component_layout_right_tablet_ads_disabled || componentOptions.component_layout_right_ads_mobile_disabled),
        "idhb-right-small-300": !(componentOptions.component_layout_right_middle_ads_disabled || componentOptions.component_layout_right_middle_tablet_ads_disabled || componentOptions.component_layout_right_middle_mobile_ads_disabled)
    };
    var adsList = Object.keys(layoutAdsElements).filter(function(key) {
        return layoutAdsElements[key];
    });
    react.useEffect(function() {
        (0,ads_request/* adsRequest */.S)(adsList);
    }, []);
    react.useEffect(function() {
        var events = router.events;
        var handleRouteChange = function() {
            if (adsList.length > 0 && !componentOptions.component_ads_disabled) {
                (0,ads_request/* adsRequest */.S)(adsList);
            }
        };
        events.on("routeChangeComplete", handleRouteChange);
        events.on("hashChangeComplete", handleRouteChange);
        return function() {
            events.off("routeChangeComplete", handleRouteChange);
            events.off("hashChangeComplete", handleRouteChange);
        };
    }, [
        router
    ]);
    return panel ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionRight, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementTop, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementBottom, {})
        ]
    }) : !componentOptions.component_ads_disabled && adsList.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionRight, {
        children: [
            lg && !componentOptions.component_layout_right_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementTop, {}),
            isBetweenMdAndLg && !componentOptions.component_layout_right_tablet_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementTop, {}),
            mdDown && !componentOptions.component_layout_right_ads_mobile_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementTop, {}),
            lg && !componentOptions.component_layout_right_middle_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementBottom, {}),
            isBetweenMdAndLg && !componentOptions.component_layout_right_middle_tablet_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementBottom, {}),
            mdDown && !componentOptions.component_layout_right_middle_mobile_ads_disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdvertisementBottom, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/layouts/LayoutA/LayoutA.tsx




var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1k4na950"
})(function() {
    return {
        display: "flex",
        flex: 1,
        flexGrow: 1,
        flexDirection: "row",
        flexWrap: "nowrap",
        alignSelf: "center",
        height: "auto",
        justifyContent: "center",
        maxWidth: "1200px",
        margin: "0 auto"
    };
});
var SectionLeft = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1k4na951"
})(function() {
    return {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        flex: 1,
        height: "auto"
    };
});
var LayoutA = function(props) {
    var children = props.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Root, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionLeft, {
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutAds, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/layouts/LayoutA/index.ts


;// CONCATENATED MODULE: ./src/generated/index/layout.tsx



function Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutA, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/generated/game/layout.tsx



function layout_Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutA, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/generated/search/layout.tsx



function search_layout_Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutA, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/generated/category/layout.tsx



function category_layout_Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutA, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/generated/categories/layout.tsx



function categories_layout_Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutA, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/generated/collection/layout.tsx



function collection_layout_Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutA, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/generated/collections/layout.tsx



function collections_layout_Layout(props) {
    var children = props.children, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LayoutA, {
        pageContext: pageContext,
        children: children
    });
}

;// CONCATENATED MODULE: ./src/layouts/BaseLayout/index.tsx




// IMPORTANT: The page.name in the import and switch case must match with the pageType set in the BaseLayoutProps definition!







var NavigationBar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4301).then(__webpack_require__.bind(__webpack_require__, 74301)).then(function(mod) {
        return mod.NavigationBarEmpty;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74301)
            ];
        }
    },
    ssr: true
});
var FooterBar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(2973)]).then(__webpack_require__.bind(__webpack_require__, 2973)).then(function(mod) {
        return mod.FooterBarEmpty;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2973)
            ];
        }
    },
    ssr: true
});
function BaseLayout(props) {
    var children = props.children, pageType = props.pageType, pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBar, {}),
            function() {
                switch(pageType){
                    case "index":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    case "game":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(layout_Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    case "search":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(search_layout_Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    case "category":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(category_layout_Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    case "categories":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(categories_layout_Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    case "collection":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(collection_layout_Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    case "collections":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(collections_layout_Layout, {
                            pageContext: pageContext,
                            children: children
                        });
                    default:
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultLayout, {
                            pageContext: pageContext,
                            children: children
                        });
                }
            }(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBar, {})
        ]
    });
}


/***/ }),

/***/ 17637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BL": function() { return /* binding */ DEVELOPMENT_USER_AVATAR_LIST; },
/* harmony export */   "LL": function() { return /* binding */ LAYOUTADSCONFIGRATION_AC_BOTTOM; },
/* harmony export */   "Tv": function() { return /* binding */ PRODUCTION_USER_AVATAR_LIST; },
/* harmony export */   "_x": function() { return /* binding */ LAYOUTADSCONFIGRATION_AC; }
/* harmony export */ });
/* unused harmony exports LAYOUTADSCONFIGRATION_B, COLLECTIONS_B_TOP, COLLECTIONS_B_MIDDLE, COLLECTIONS_B_BOTTOM */
var DEVELOPMENT_USER_AVATAR_LIST = [
    "e7f150de-693c-40f8-b99f-6f391497924f",
    "54df2df6-6893-44ff-bd59-dc5f069d4966",
    "0cda05de-d9c7-4559-972a-2b254eb5edeb",
    "e3853542-29d3-4067-ab73-6f43e42ba0f6",
    "968ff027-b6e6-4be7-92fc-0028916d76e8",
    "072fadf5-62ff-4e8a-86ae-f3d4d5cb5122", 
];
var PRODUCTION_USER_AVATAR_LIST = [
    "f7ffed9a-12d6-4483-94d1-4d9976d69529",
    "3d89d0c3-72c7-4e8e-91d2-91be99c5f642",
    "ba16bc1b-45fd-4af5-a534-05138ab48735",
    "e96a3df4-1589-45cc-b440-f1320faef777",
    "2ff729ff-9341-4803-bb15-595a69bcab0a",
    "552bcaf1-7302-4771-a2ac-97971f665842", 
];
var LAYOUTADSCONFIGRATION_AC = [
    {
        name: "component_layout_right_ads_disabled",
        label: "Close the desktop ad space.",
        type: "checkbox",
        default: false
    },
    {
        name: "component_layout_right_tablet_ads_disabled",
        label: 'Close the tablet ad space"',
        type: "checkbox",
        default: false
    },
    {
        name: "component_layout_right_ads_mobile_disabled",
        label: 'Close the mobile ad space."',
        type: "checkbox",
        default: false
    }, 
];
var LAYOUTADSCONFIGRATION_AC_BOTTOM = [
    {
        name: "component_layout_right_middle_ads_disabled",
        label: "Close the desktop ad space.",
        type: "checkbox",
        default: false
    },
    {
        name: "component_layout_right_middle_tablet_ads_disabled",
        label: 'Close the tablet ad space"',
        type: "checkbox",
        default: false
    },
    {
        name: "component_layout_right_middle_mobile_ads_disabled",
        label: 'Close the mobile ad space."',
        type: "checkbox",
        default: false
    }, 
];
var LAYOUTADSCONFIGRATION_B = [
    {
        name: "component_layout_right_ads_disabled",
        label: "Close the desktop ad space.",
        type: "checkbox",
        default: false
    },
    {
        name: "component_layout_right_ads_tablet_disabled",
        label: 'Close the tablet ad space"',
        type: "checkbox",
        default: false
    },
    {
        name: "component_layout_right_ads_mobile_disabled",
        label: 'Close the mobile ad space."',
        type: "checkbox",
        default: false
    }, 
];
var COLLECTIONS_B_TOP = [
    {
        name: "component_right_ads_disable",
        label: "Close the desktop ad space.",
        type: "checkbox",
        default: false
    },
    {
        name: "component_right_ads_tablet_disable",
        label: 'Close the tablet ad space"',
        type: "checkbox",
        default: false
    },
    {
        name: "component_right_ads_mobile_disable",
        label: 'Close the mobile ad space."',
        type: "checkbox",
        default: false
    }, 
];
var COLLECTIONS_B_MIDDLE = [
    {
        name: "component_middle_center_ads_disable",
        label: "Close the desktop ad space.",
        type: "checkbox",
        default: false
    },
    {
        name: "component_middle_center_ads_tablet_disable",
        label: 'Close the tablet ad space"',
        type: "checkbox",
        default: false
    },
    {
        name: "component_middle_center_ads_mobile_disable",
        label: 'Close the mobile ad space."',
        type: "checkbox",
        default: false
    }, 
];
var COLLECTIONS_B_BOTTOM = [
    {
        name: "component_bottom_ads_disable",
        label: "Close the desktop ad space.",
        type: "checkbox",
        default: false
    },
    {
        name: "component_bottom_ads_tablet_disable",
        label: 'Close the tablet ad space"',
        type: "checkbox",
        default: false
    },
    {
        name: "component_bottom_ads_mobile_disable",
        label: 'Close the mobile ad space."',
        type: "checkbox",
        default: false
    }, 
];


/***/ }),

/***/ 18505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ adsRequest; }
/* harmony export */ });
var adsRequest = function(banners) {
    if (banners.length >= 1) {
        var ref;
        window.idhb = (window === null || window === void 0 ? void 0 : window.idhb) || {};
        window.idhb.que = ((ref = window.idhb) === null || ref === void 0 ? void 0 : ref.que) || [];
        window.idhb.que.push(function() {
            console.info("[hl]", banners);
            window.idhb.requestAds({
                // slotIds is optional. If not specified, ads for all configured slots on the page will be requested
                slotIds: banners
            });
        });
    }
};


/***/ })

}]);